// import Footer from './Footer';
// import UserMarket from '../UserMarket';
import { useDisclosure } from '@/utils/hooks/useDisclosure';
import useScreenSizes from '@/utils/hooks/useScreenSizes';
import cn from 'classnames';
import { useMemo, useState } from 'react';
import Footer from './Footer';
import MobileSubHeader from './MobileSubHeader';
import Navbar from './Navbar';
import UniversalSidebar from './UniversalSidebar';
import TraderFooter from './trader/TraderFooter';

interface LayoutProps extends React.PropsWithChildren {
    prevPath: string | null;
}

export default function Layout({ prevPath, children }: LayoutProps) {
    const pathname = window.location.pathname;

    const settings = useDisclosure(false);
    const { mobile, tablet } = useScreenSizes();

    const [isExpanded, setIsExpanded] = useState(
        prevPath?.includes('/portal') || prevPath?.includes('/lite') ? true : false
    );

    const isMobile = useMemo(() => mobile || tablet, [mobile, tablet]);

    const width = useMemo(() => {
        if (isMobile) {
            return '100%';
        } else {
            return isExpanded ? 'calc(100% - 257px)' : 'calc(100% - 61px)';
        }
    }, [isExpanded, isMobile]);

    const marginLeft = useMemo(() => {
        if (isMobile) {
            return 0;
        } else {
            return isExpanded ? 257 : 61;
        }
    }, [isExpanded, isMobile]);

    return (
        <div className="flex flex-col">
            <UniversalSidebar isExpanded={isExpanded} setIsExpanded={setIsExpanded} settingsDisclosure={settings} />
            <div
                className={cn('flex flex-col', {
                    'transition-all duration-200': !isMobile
                })}
                style={{ width, marginLeft, direction: 'ltr' }}>
                <Navbar settings={settings} />
                <MobileSubHeader />
                <main className="trading-layout">{children}</main>
                {pathname.includes('trader') ? <TraderFooter /> : <Footer />}
            </div>
        </div>
    );
}
